/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.0.4",
  "gitBuildTime": "2023-02-28T20:29:55.180Z",
  "gitBuildVersion": "1.0.4",
  "gitCommitId": "e8a61b4",
  "gitCommitIdFull": "e8a61b413ee7dccccbb05a7f65fcbf68ea62ca9b",
  "gitCommitTime": "2023-02-28T20:28:47.000Z",
  "version": "1.0.4-2023-02-28T20:28:47.000Z-(e8a61b4)"
};
